import home from '../page/home/home'
import guide from '../page/home/guide'
import guideList from '../page/home/guide-list'
import pay from '../page/home/pay'
import orderList from '../page/home/order-list'
import create from '../page/home/order-create'
import desc from '../page/home/order-desc'
import orderShare from '../page/home/order-share'
import comment from '../page/home/comment'
import orderRefund from '../page/home/order-refund'
import orderSign from '../page/home/order-sign'
import orderTeamIndex from '../page/home/order-team-index'
import orderListIndex from '../page/home/order-list-index'
import orderTeam from '../page/home/order-team'
import orderListTeam from '../page/home/order-team-list'
import orderTeamDesc from '../page/home/order-team-desc'
import cover from '../page/home/cover'
import piao from '../page/home/piao'

/* 登录授权 */
import system1 from '../page/400/401'
/* 系统维护中 */
import system from '../page/400/400'
/* 404必须是最后一个路由 */
import notFound from '../page/404/404'
export default [
  {
    path: '/',
    meta: {
      keepAlive: true,
      title: '导游预约'
    },
    name: 'home',
    //component: orderTeam
    component: home
  },
  {
    path: '/cover',
    meta: {
      keepAlive: true,
      title: '导游预约'
    },
    name: 'cover',
    component: cover
  },
  {
    path: '/guide',
    meta: {
      keepAlive: false,
      title: '金牌讲解员'
    },
    name: 'guide',
    component: guide
  },
  {
    path: '/guide-list',
    meta: {
      keepAlive: false,
      title: '金牌讲解员'
    },
    name: 'guideList',
    component: guideList
  },
  {
    path: '/pay',
    meta: {
      keepAlive: false,
      title: '预约讲解'
    },
    name: 'pay',
    component: pay
  },
  {
    path: '/order-list',
    meta: {
      keepAlive: false,
      title: '我的订单'
    },
    name: 'orderList',
    component: orderList
  },
  {
    path: '/order-create',
    meta: {
      keepAlive: false,
      title: '提交订单'
    },
    name: 'create',
    component: create
  },
  {
    path: '/order-desc',
    meta: {
      keepAlive: false,
      title: '订单详情'
    },
    name: 'desc',
    component: desc
  },
  {
    path: '/order-share',
    meta: {
      keepAlive: false,
      title: '拼团'
    },
    name: 'orderShare',
    component: orderShare
  },
  {
    path: '/comment',
    meta: {
      keepAlive: false,
      title: '评价'
    },
    name: 'comment',
    component: comment
  },
  {
    path: '/order-refund',
    meta: {
      keepAlive: false,
      title: '取消订单'
    },
    name: 'orderRefund',
    component: orderRefund
  },
  {
    path: '/order-sign',
    meta: {
      keepAlive: false,
      title: '签到'
    },
    name: 'orderSign',
    component: orderSign
  },
  {
    path: '/piao',
    meta: {
      keepAlive: false,
      title: '申请开票'
    },
    name: 'piao',
    component: piao
  },
  {
    path: '/order-team-index',
    meta: {
      keepAlive: false,
      title: '四川博物院'
    },
    name: 'orderTeamIndex',
    component: orderTeamIndex
  },
  {
    path: '/order-team',
    meta: {
      keepAlive: false,
      title: '团队预约'
    },
    name: 'orderTeam',
    component: orderTeam
  },
  {
    path: '/order-team-list',
    meta: {
      keepAlive: false,
      title: '我的预约'
    },
    name: 'orderListTeam',
    component: orderListTeam
  },
  {
    path: '/order-list-index',
    meta: {
      keepAlive: false,
      title: '我的预约'
    },
    name: 'orderListIndex',
    component: orderListIndex
  },
  {
    path: '/order-team-desc',
    meta: {
      keepAlive: false,
      title: '预约详情'
    },
    name: 'orderTeamDesc',
    component: orderTeamDesc
  },
  {
    path: '/401',
    meta: {
      keepAlive: false,
      title: '用户授权'
    },
    component: system1
  },
  {
    path: '/400',
    meta: {
      keepAlive: false,
      title: '系统维护中'
    },
    component: system
  },
  { /* 404必须是最后一个路由 */
    path: '*',
    meta: {
      keepAlive: false,
      title: '找不到页面'
    },
    component: notFound
  }

]



// WEBPACK FOOTER //
// ./src/router/index.js